// extracted by mini-css-extract-plugin
module.exports = {"form":"vd__2C-kU","footer":"vd__15eHT"};